export type AgentScope = 'social:read' | 'social:draft' | 'social:publish' | 'browser:read' | 'browser:handoff' | 'browser:execute';
export const agentScopeLabels: Record<AgentScope, string> = {
  'social:read': 'Lesen', 'social:draft': 'Entwürfe erstellen', 'social:publish': 'Veröffentlichen & planen',
  'browser:read': 'Browser-Aufträge lesen', 'browser:handoff': 'Browser-Aufträge vorbereiten', 'browser:execute': 'Lokalen Browser bedienen',
};
export function agentApiUrl(path: string) {
  const base = ((import.meta.env.VITE_API_URL as string | undefined) || '/api').replace(/\/+$/, '');
  return new URL(`${base}${path}`, window.location.origin).toString();
}
